import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "./Header";
import SideBar from "./SideBar";
import NavBar from "./NavBar";
import Footer from "./Footer";
import useAuth from "@/hooks/useAuth";

const MainOutlet = () => {
  const location = useLocation();
  const isAuthenticated = useAuth();
  const [hide, setHide] = useState(
    localStorage.getItem("minimalMode") === "true"
  );
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const minimalMode = params.has("minimal");
    const veeMode = params.has("vee");
    if (minimalMode) {
      if (veeMode) {
        navigate("vee", { replace: true });
      }
      if (typeof localStorage.getItem("hes_token") === "string" && !veeMode) {
        navigate("sat", { replace: true });
      }
      localStorage.setItem("minimalMode", "true");
      setHide(true); // Ensure UI updates immediately
    }

    // Keep minimal mode active even if `minimal` is missing from subsequent routes
  }, [location.search]);

  // Detect hard refresh and clear minimalMode
  useEffect(() => {
    const handleHardRefresh = () => {
      localStorage.removeItem("minimalMode");
    };

    window.addEventListener("beforeunload", handleHardRefresh);
    return () => window.removeEventListener("beforeunload", handleHardRefresh);
  }, []);

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/auth"
        replace
      />
    );
  }

  if (hide) {
    return <Outlet />;
  }

  return (
    <div className="flex flex-col relative main-app">
      <SideBar />
      <NavBar />
      <Header />
      <div className="custom-main flex flex-col transition-all">
        <Outlet />
        <Footer />
      </div>
    </div>
  );
};

export default MainOutlet;
